import { muiPalette } from './muiPalette';

export const buttonOverride = {
  MuiButton: {
    styleOverrides: {
      root: {
        '&.Mui-disabled': {
          color: muiPalette.palette.text.disabled
        }
      },
      text: {
        padding: '8px 16px',
        '&.Mui-focusVisible': {
          backgroundColor: muiPalette.palette.action.focus
        },
        '&:focus': {
          backgroundColor: muiPalette.palette.action.focus
        },
        '&.alert': {
          color: muiPalette.palette.error.main,
          '&.Mui-disabled': {
            color: muiPalette.palette.text.disabled
          }
        },
        '&.grey': {
          color: muiPalette.palette.grey[700],
          '&.Mui-disabled': {
            color: muiPalette.palette.text.disabled
          }
        }
      },
      outlined: {
        padding: '7px 15px',
        '&.Mui-focusVisible': {
          backgroundColor: muiPalette.palette.action.focus
        },
        '&:focus': {
          backgroundColor: muiPalette.palette.action.focus
        }
      },
      contained: {
        padding: '8px 16px',
        boxShadow: 'none',
        '&.Mui-focusVisible': {
          boxShadow: `inset 0px 0px 0px 2px ${muiPalette.palette.primary.dark}`
        },
        '&:hover': {
          boxShadow: 'none'
        },
        '&.alert': {
          backgroundColor: muiPalette.palette.error.main,
          color: muiPalette.palette.error.contrastText,
          '&:hover': {
            background: muiPalette.palette.error.dark
          },
          '&.Mui-disabled': {
            backgroundColor: muiPalette.palette.action.disabledBackground,
            color: muiPalette.palette.text.disabled
          },
          '&.Mui-focusVisible': {
            boxShadow: `inset 0px 0px 0px 2px ${muiPalette.palette.error.dark}`
          }
        }
      },
      textPrimary: {
        '&:hover': {
          backgroundColor: muiPalette.palette.action.hover
        }
      },
      textSecondary: {
        '&:hover': {
          backgroundColor: muiPalette.palette.action.hover
        }
      },
      outlinedPrimary: {
        border: `1px solid ${muiPalette.palette.primary.main}`,
        '&:hover': {
          backgroundColor: muiPalette.palette.action.hover
        }
      },
      outlinedSecondary: {
        '&:hover': {
          backgroundColor: muiPalette.palette.action.hover
        }
      },
      sizeSmall: ({ ownerState }) => ({
        fontSize: 14,
        padding: ownerState.variant === 'outlined' ? '3px 11px' : '4px 12px'
      })
    }
  }
};
